import React, {useEffect, useState } from "react";
import MainPage from "./mainPage";
import RealizationsPanel from "./realizations";
import Login from "./login";
import Adminoffert from "./offert";
import Panelreferences from "./references";

export default function MainPagePanel() {
	const [View, setView] = useState(1);
	const [user, setUser] = useState(null);
	
	useEffect(() => {
		localStorage.getItem('adminUser') ? setUser(JSON.parse(localStorage.getItem('adminUser'))) : setView(0);
	}, []);
	
	return (
		<main className="MainPage">
			<div className='Menu'>
				<nav className="navbar navbar-expand-lg bg-body-tertiary">
					<div className="container-fluid">
						<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M120-120v-560h160v-160h400v320h160v400H520v-160h-80v160H120Zm80-80h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 320h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 480h80v-80h-80v80Zm0-160h80v-80h-80v80Z" /></svg>
						<a
							className="navbar-brand"
							href="/"
							onClick={(e) => setView(e, '/')}
						>
							MEGAMONT
						</a>
						<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
							<span className="navbar-toggler-icon"></span>
						</button>
						<div className="collapse navbar-collapse" id="navbarNavAltMarkup">
							<div className="navbar-nav">
								<a className={`nav-link btn ${View == 1 ? 'View' : ''}`} onClick={(e) => setView(1)}>Strona Główna</a>
								<a className={`nav-link btn ${View == 2 ? 'View' : ''}`} onClick={(e) => setView(2)}>Realizacje</a>
								<a className={`nav-link btn ${View == 3 ? 'View' : ''}`} onClick={(e) => setView(3)}>Oferta</a>
								<a className={`nav-link btn ${View == 4 ? 'View' : ''}`} onClick={(e) => setView(4)}>Referencje</a>
							</div>
						</div>
					</div>
				</nav>
			</div>
			<div className="container">
				{View === 0 && <Login setView={setView}/>}
				{View === 1 && <MainPage/>}
				{View === 2 && <RealizationsPanel/>}
				{View === 3 && <Adminoffert/>}
				{View === 4 && <Panelreferences/>}
			</div>
		</main>
	)
}

